import { CaseHistoryEntryDto, CaseInteractionDto } from '../models/collection-case.model';
import { TimelineEvent } from '../../ui/ui.types';

export interface CollectionActionApiDto {
  id?: string | number;
  actionId?: string | number;
  type?: string;
  actionType?: string;
  channel?: string;
  plannedDate?: string;
  scheduledDate?: string;
  executionDate?: string;
  status?: string;
  result?: string;
  outcome?: string;
  comment?: string;
  report?: string;
  createdAt?: string;
  createdBy?: string;
  agentName?: string;
  promiseAmount?: number;
  promiseDate?: string;
}

export function mapApiActionToInteraction(value: unknown): CaseInteractionDto {
  const action = (value ?? {}) as CollectionActionApiDto;
  return {
    interactionId: String(action.actionId ?? action.id ?? ''),
    channel: String(action.channel ?? action.type ?? 'PHONE'),
    actionLabel: String(action.actionType ?? action.type ?? 'Action'),
    interactionDate: String(action.executionDate ?? action.plannedDate ?? action.scheduledDate ?? action.createdAt ?? ''),
    agentName: String(action.agentName ?? action.createdBy ?? ''),
    outcome: String(action.result ?? action.outcome ?? action.status ?? ''),
    hasPromise: action.promiseAmount != null || action.promiseDate != null,
    promiseAmount: action.promiseAmount,
    promiseDate: action.promiseDate,
  };
}

export function mapApiActionToHistory(value: unknown): CaseHistoryEntryDto {
  const action = (value ?? {}) as CollectionActionApiDto;
  const interaction = mapApiActionToInteraction(action);
  return {
    entryId: interaction.interactionId,
    entryDate: interaction.interactionDate,
    actor: interaction.agentName,
    action: String(action.status ?? 'Action'),
    details: [interaction.actionLabel, interaction.outcome, action.comment ?? action.report].filter(Boolean).join(' — '),
  };
}

export function actionInteractionToTimeline(interaction: CaseInteractionDto): TimelineEvent {
  const channel = toTimelineChannel(interaction.channel);
  const date = parseBusinessDate(interaction.interactionDate);
  return {
    id: interaction.interactionId,
    date,
    channel,
    type: 'action',
    description: [interaction.actionLabel, interaction.outcome].filter(Boolean).join(' — '),
    agent: interaction.agentName,
  };
}

function toTimelineChannel(value: string): TimelineEvent['channel'] {
  const normalized = value.toUpperCase();
  if (normalized.includes('SMS')) return 'sms';
  if (normalized.includes('EMAIL') || normalized.includes('MAIL')) return 'email';
  if (normalized.includes('LETTER') || normalized.includes('COURRIER')) return 'lettre';
  if (normalized.includes('VISIT') || normalized.includes('REUNION')) return 'reunion';
  return 'telephone';
}

function parseBusinessDate(value: string): Date {
  if (!value) return new Date();
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }
  return new Date(value);
}
